import { Controller } from "@hotwired/stimulus"

/**
 * Admin Dropdown Controller - Simple dropdown menu
 *
 * Usage:
 * <div data-controller="admin-dropdown">
 *   <button data-action="click->admin-dropdown#toggle">Toggle</button>
 *   <div data-admin-dropdown-target="menu" class="hidden">Menu content</div>
 * </div>
 */
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Close dropdown when clicking outside
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.boundHandleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
